import { Component, OnInit, Input, ViewChild, OnDestroy } from "@angular/core";
import { settingsMenuAnimations } from "@/_utility/animations";
import { isAsapAccount } from "@/_models/account.interface";
import { shareReplay, takeUntil } from "rxjs/operators";
import { Observable, Subject } from "rxjs";
import { UserService } from "@/_services";
import UserModel = UserDm.UserModel;
import { UserDm } from "@/_models";
import { OnboardingStatus } from "@/_models/onboarding-status.interface";
import { QuickStartGuideService } from "@/_services/quick-start-guide.service";
import { QuickStartGuideComponent } from "@/components/shared/quick-start-guide/quick-start-guide.component";
import { OnboardingStateService } from "@/_services/onboarding-state.service";

@Component({
    selector: "app-mobile-menu",
    templateUrl: "./mobile-menu.component.html",
    styleUrls: ["./mobile-menu.component.scss"],
    animations: settingsMenuAnimations,
})
export class MobileMenuComponent implements OnInit, OnDestroy {
    @ViewChild("qsMobile") qsMobile!: QuickStartGuideComponent;
    @ViewChild("quickStartMobileButton") quickStartMobileButton!: any;

    currentUser$: Observable<UserModel>;
    onboardingStatus$: Observable<OnboardingStatus | null>;
    asapFormId$: Observable<string | null>;
    private destroy$ = new Subject<void>();
    isMenuOpened: boolean;
    isAsap = false;

    constructor(
        private userService: UserService,
        private quickStartGuideService: QuickStartGuideService,
        private onboardingState: OnboardingStateService,
    ) {}

    ngOnInit() {
        this.currentUser$ = this.userService
            .getCurrentUserAsync()
            .pipe(shareReplay());

        this.currentUser$.subscribe((user) => {
            this.isAsap = isAsapAccount(user.account);
        });

        this.onboardingStatus$ = this.onboardingState.onboardingStatus$;
        this.asapFormId$ = this.onboardingState.asapFormId$;

        this.quickStartGuideService.quickStartState$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                const syntheticEvent = {
                    target: this.quickStartMobileButton?.nativeElement,
                    currentTarget: this.quickStartMobileButton?.nativeElement,
                    preventDefault: () => {},
                    stopPropagation: () => {},
                } as Event;

                if (this.qsMobile) {
                    this.qsMobile.toggle(syntheticEvent);
                }
            });
    }

    toggleMenu(state: boolean) {
        this.isMenuOpened = state;
    }

    openQuickStart(event: Event) {
        this.quickStartGuideService.toggle(event);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    isOnboardingCompleted(status: OnboardingStatus | null): boolean {
        if (!status) return false;
        let count = 0;
        if (status?.hasReportRecipients) count++;
        if (status?.hasAddedUsers) count++;
        if (status?.hasGeneratedQrCode) count++;
        return count === 3;
    }
}
